import React from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { Link } from 'react-router';
import styles from 'styles';
import { types as TYPES_BY_PURPOSE } from 'constants/vesselTypes';
import TypeBySpecialty from '../Single/Rows/TypeBySpecialty';
import { CenterBox } from './utils';
import DataFillRatioFilter from './DataFillRatioFilter';

const getDate = (type) => {
    const date = new Date();
    switch (type) {
    case 'week': date.setDate(date.getDate() - 7); return date;
    case 'month': date.setMonth(date.getMonth() - 1); return date;
    case 'year': date.setFullYear(date.getFullYear() - 1); return date;
    default: return date;
    }
};

const exclusionsAndRestrictions = [
    { date: null, label: 'Any' },
    { date: getDate('week'), label: 'Last Week' },
    { date: getDate('month'), label: 'Last Month' },
    { date: getDate('year'), label: 'Last Year' },
];

const filterRowStyle = {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    gap: 16,
    width: '70%',
};

const selectStyle = {
    width: 150,
    fontSize: '13px',
};

const labelStyle = {
    left: '0',
    fontSize: '13px',
};

const numberInputStyle = {
    width: 90,
    fontSize: '13px',
};

const checkboxStyle = {
    display: 'inline-block',
    width: 'auto',
    whiteSpace: 'nowrap',
};

const checkboxLabelStyle = {
    fontSize: '13px',
};

const Delimiter = () => <span style={{ borderLeft: '1px solid #ccc', height: 28, margin: '0 4px' }} />;

export default function VesselsListFilters({
    searchRef,
    defaultSearchValue,
    clearSearch,
    handleSearch,
    handleNameSuggested,
    handleFilters,
    filterCargoExclusions,
    filterTradingRestrictions,
    handleExclusions,
    handleSanctioned,
    rightPart,
    handleConfirmed,
    handleMarkedToDelete,
    /** @type {{ dwtMin?: string, dwtMax?: string, bltMin?: string, bltMax?: string }} */
    errors = {},

    filters: {
        isNameSuggestion,
        suggestionSource,
        isMarkedToDelete,
        notConfirmed,
        modifiedFilter,
        photosFilter,
        sanctioned,
        typeByPurpose,
        typeBySpecialty,
        dwtMin,
        dwtMax,
        bltMin,
        bltMax,
        sortValue,
        sortField,
        dataFillRatio,
    },
}) {
    return (
        <React.Fragment>
            <div className='table-header'>
                <div className='item' style={{ width: '70%' }}>
                    <div style={{
                        display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 12,
                    }}
                    >
                        <TextField
                            defaultValue={defaultSearchValue}
                            floatingLabelText='Search by IMO or name'
                            ref={searchRef}
                            style={{ width: 200 }}
                            onChange={clearSearch}
                            onKeyPress={(event) => {
                                if (event.charCode === 13) {
                                    event.preventDefault();
                                    handleSearch();
                                }
                            }}
                        />
                        <RaisedButton
                            label='Search'
                            style={styles.RaisedButton}
                            primary
                            onClick={handleSearch}
                        />

                        <Delimiter />

                        <Checkbox
                            label='Not confirmed'
                            checked={notConfirmed}
                            onCheck={handleConfirmed}
                            style={checkboxStyle}
                            labelStyle={checkboxLabelStyle}
                        />
                        <div style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 8,
                            padding: '0 12px',
                            backgroundColor: isNameSuggestion ? '#f0f7ff' : '#f5f5f5',
                            borderRadius: 4,
                            border: isNameSuggestion ? '1px solid #2196F3' : '1px solid #e0e0e0',
                            transition: 'all 0.2s ease',
                        }}
                        >
                            <Checkbox
                                label='Rename suggestion'
                                checked={isNameSuggestion}
                                onCheck={handleNameSuggested}
                                style={checkboxStyle}
                                labelStyle={checkboxLabelStyle}
                                iconStyle={{ marginRight: 6 }}
                            />
                            {isNameSuggestion && (
                                <React.Fragment>
                                    <span style={{
                                        borderLeft: '1px solid #ccc',
                                        height: 28,
                                    }}
                                    />
                                    <SelectField
                                        floatingLabelText='Source'
                                        floatingLabelStyle={labelStyle}
                                        value={suggestionSource || 'all'}
                                        onChange={(_e, _i, val) => handleFilters('suggestionSource', val)}
                                        style={selectStyle}
                                        fullWidth
                                    >
                                        <MenuItem value='all' primaryText='All' />
                                        <MenuItem value='equasis-parser' primaryText='Equasis' />
                                        <MenuItem value='vessel-updater' primaryText='Vessel Updater' />
                                    </SelectField>
                                </React.Fragment>
                            )}
                        </div>
                        <Checkbox
                            label='Sanctioned'
                            checked={sanctioned}
                            onCheck={handleSanctioned}
                            style={checkboxStyle}
                            labelStyle={checkboxLabelStyle}
                        />
                        <Checkbox
                            label="Marked to delete"
                            checked={isMarkedToDelete}
                            onCheck={handleMarkedToDelete}
                            style={{
                                display: 'inline-block', margin: '0 0 0 10px', width: '160px', textAlign: 'start', 
                            }}
                            labelStyle={{ fontSize: '13px', width: '100%' }}
                        />
                    </div>
                </div>
                <div className='item' style={{ width: '30%' }}>
                    {rightPart}
                </div>
            </div>

            <div className='table-header'>
                <div className='item' style={filterRowStyle}>
                    <SelectField
                        floatingLabelText='Type by purpose'
                        floatingLabelStyle={labelStyle}
                        value={typeByPurpose || ''}
                        onChange={(_e, _i, val) => handleFilters('typeByPurpose', val || '')}
                        style={selectStyle}
                    >
                        <MenuItem value='' primaryText='' />
                        {TYPES_BY_PURPOSE.map(tp => (
                            <MenuItem key={tp} value={tp} primaryText={tp} />
                        ))}
                    </SelectField>

                    <TypeBySpecialty
                        typeBySpecialty={typeBySpecialty || ''}
                        fromTcOrder={false}

                        style={selectStyle}
                        changeField={(vals) => {
                            const v = vals.find(val => val.field === 'typeBySpecialty').value;
                            return handleFilters(
                                'typeBySpecialty',
                                v === '' ? undefined : v,
                            );
                        }
                        }
                        typeByPurpose={typeByPurpose}
                        withoutSpecialtyEnabled
                    />

                    <Delimiter />

                    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
                        <TextField
                            floatingLabelText='DWT min'
                            type='number'
                            value={dwtMin || ''}
                            onChange={(_e, v) => handleFilters('dwtMin', v === '' ? null : Number(v))}
                            style={numberInputStyle}
                            errorText={errors.dwtMin || ''}
                        />
                        <span style={{ paddingBottom: 10, color: '#888' }}>–</span>
                        <TextField
                            floatingLabelText='DWT max'
                            type='number'
                            value={dwtMax || ''}
                            onChange={(_e, v) => handleFilters('dwtMax', v === '' ? null : Number(v))}
                            style={numberInputStyle}
                            errorText={errors.dwtMax || ''}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
                        <TextField
                            floatingLabelText='BLT min'
                            type='number'
                            value={bltMin || ''}
                            onChange={(_e, v) => handleFilters('bltMin', v === '' ? null : Number(v))}
                            style={numberInputStyle}
                            errorText={errors.bltMin || ''}
                        />
                        <span style={{ paddingBottom: 10, color: '#888' }}>–</span>
                        <TextField
                            floatingLabelText='BLT max'
                            type='number'
                            value={bltMax || ''}
                            onChange={(_e, v) => handleFilters('bltMax', v === '' ? null : Number(v))}
                            style={numberInputStyle}
                            errorText={errors.bltMax || ''}
                        />
                    </div>

                    {/* <SelectField
                        floatingLabelText='Sort by BLT'
                        floatingLabelStyle={labelStyle}
                        value={sortField === 'blt' ? sortValue : null}
                        onChange={(_e, _i, val) => {
                            const isBlank = val == null;
                            handleFilters({
                                sortField: isBlank ? undefined : 'blt',
                                sortValue: isBlank ? undefined : val,
                            });
                        }}
                        style={{ ...selectStyle, width: 130 }}
                    >
                        <MenuItem value={null} primaryText='' />
                        <MenuItem value={-1} primaryText='Newest first' />
                        <MenuItem value={1} primaryText='Oldest first' />
                    </SelectField> */}

                    <Delimiter />

                    <DataFillRatioFilter
                        dataFillRatio={dataFillRatio}
                        handleFilters={handleFilters}
                    />

                </div>
                <div className='item' style={{ width: '30%' }}>
                    <CenterBox>
                        <RaisedButton
                            label="ADD NEW VESSEL"
                            style={styles.RaisedButton}
                            primary
                            containerElement={<Link to="/vessels/add" />}
                        />
                    </CenterBox>
                </div>
            </div>

            <div className='table-header'>
                <div className='item' style={filterRowStyle}>
                    <SelectField
                        floatingLabelText='Modified'
                        floatingLabelStyle={labelStyle}
                        value={modifiedFilter}
                        onChange={(_ev, _idx, val) => handleFilters('modifiedFilter', val)}
                        style={selectStyle}
                    >
                        <MenuItem value='all' primaryText='All' />
                        <MenuItem value='modified' primaryText='Modified' />
                        <MenuItem value='notModified' primaryText='Not modified' />
                    </SelectField>

                    <SelectField
                        floatingLabelText='Photos'
                        floatingLabelStyle={labelStyle}
                        value={photosFilter}
                        onChange={(_ev, _idx, val) => handleFilters('photosFilter', val)}
                        style={selectStyle}
                    >
                        <MenuItem value='all' primaryText='All' />
                        <MenuItem value='withPhotos' primaryText='With photos' />
                        <MenuItem value='withoutPhotos' primaryText='Without photos' />
                    </SelectField>

                    <Delimiter />

                    <SelectField
                        floatingLabelText='Cargo exclusions'
                        floatingLabelStyle={labelStyle}
                        value={filterCargoExclusions}
                        onChange={(_ev, _idx, val) => handleExclusions(val, 'filterCargoExclusions')}
                        style={{ ...selectStyle, width: 160 }}
                    >
                        {exclusionsAndRestrictions.map((excl, idx) => (
                            <MenuItem
                                key={idx}
                                value={excl.date ? excl.date.toISOString() : null}
                                primaryText={excl.label}
                            />
                        ))}
                    </SelectField>

                    <SelectField
                        floatingLabelText='Trading restrictions'
                        floatingLabelStyle={labelStyle}
                        value={filterTradingRestrictions}
                        onChange={(_ev, _idx, val) => handleExclusions(val, 'filterTradingRestrictions')}
                        style={{ ...selectStyle, width: 170 }}
                    >
                        {exclusionsAndRestrictions.map((excl, idx) => (
                            <MenuItem
                                key={idx}
                                value={excl.date ? excl.date.toISOString() : null}
                                primaryText={excl.label}
                            />
                        ))}
                    </SelectField>

                    <span style={{ borderLeft: '1px solid #ccc', height: 28, margin: '0 4px' }} />

                    <SelectField
                        floatingLabelText="Sort by"
                        floatingLabelStyle={{ left: '0', fontSize: '13px' }}
                        value={sortField}
                        onChange={(_e, _i, val) => handleFilters('sortField', val)}
                        style={{ width: 150, textAlign: 'left', fontSize: '13px' }}
                    >
                        <MenuItem value="name" primaryText="Name" />
                        <MenuItem value="blt" primaryText="BLT" />
                        {isMarkedToDelete && (
                            <MenuItem value="markForDeletionDate" primaryText="Deletion Date" />
                        )}
                    </SelectField>

                    <SelectField
                        floatingLabelText="Order"
                        floatingLabelStyle={{ left: '0', fontSize: '13px' }}
                        value={sortValue}
                        onChange={(_e, _i, val) => handleFilters('sortValue', val)}
                        style={{ width: 100, textAlign: 'left', fontSize: '13px' }}
                    >
                        <MenuItem value={1} primaryText="Asc" />
                        <MenuItem value={-1} primaryText="Desc" />
                    </SelectField>

                </div>
            </div>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./app/components/Vessels/List/Filters.jsx